import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
//@ts-ignore
import {ReactComponent as Nitrogen} from '../../assets/icone_azote.svg';

interface HeaderIconProps extends SvgIconProps {
  selected: boolean;
  baseColor?: string;
}

const NitrogenIcon: React.FC<HeaderIconProps> = (props) => {
  const {selected, baseColor, ...svgProps} = props;

  return (
    <SvgIcon
      {...svgProps}
      component={Nitrogen}
      style={{
        fillOpacity: props.baseColor ? '1' : props.selected ? '1' : '0.5',
        color: props.baseColor && !props.selected ? props.baseColor : '#FFFFFF',
      }}
      viewBox='0 0 16 16'
    />
  );
};

export default NitrogenIcon;
